import axios from "axios";
import * as Sentry from "@sentry/browser";
// import { stringify } from "querystring";
import { getServiceEndpoints } from "../yoello-lib/modules/environments/services";

export function getFullURL() {
  const stage = process.env.REACT_APP_STAGE;
  const overwriteHost = process.env.REACT_APP_SERVICE_ENDPOINT;

  let services = getServiceEndpoints(stage, overwriteHost);
  return services["consumerAPI"];
}

export const URL = getFullURL();

const instance = axios.create({
  baseURL: URL,
  headers: {
    "content-type": "application/json",
  },
  responseType: "json",
});

function handleAxiosError(err) {
  /**On API failures add a sentry message, might be useful for tracking down errors */
  if (typeof err === "object") {
    /**Didn't want any unexpected errors */
    try {
      const error = {
        ...err,
        responseData: JSON.stringify(err?.response?.data),
      };
      console.log(error.responseData);
      Sentry.captureMessage(JSON.stringify(error));
    } catch (error) {}
  }
  throw err;
}
instance.interceptors.response.use(undefined, handleAxiosError);
export default instance;
